var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_c('img',{attrs:{"src":require('@/assets/welcome-rise.svg'),"width":"760"}}),_c('h1',[_vm._v("Bem-vindo ao RISE")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }